import { createTheme } from '@mui/material/styles';
import { breakpoints } from './breakpoints';
import { components } from './components';
import { darkPalette, lightPalette } from './palette';
import { shadows } from './shadows';
import { shape } from './shape';
import { typography } from './typography';

export type Mode = 'light' | 'dark';

/** The MUI theme for one mode. Built by `AppThemeProvider`, which picks the
 *  mode from Settings. */
export function makeTheme(mode: Mode) {
	return createTheme({
		palette: mode === 'dark' ? darkPalette : lightPalette,
		typography,
		breakpoints,
		shape,
		shadows,
		components: {
			...components,
			/* MUI lightens raised paper in dark mode with a white overlay; the
         surfaces here come from the tokens instead, so drop it. */
			MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
		},
	});
}

export default makeTheme('light');
